import React from 'react';
import PropTypes from 'prop-types';

class User extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: true,
      user: new Monet.UI.Fields.Render({
        name: 'users',
        mandatory: false,
        type: 'LOOKUP',
        lookupEntity: 'Users',
        lookupEntityColumn: 'name'
        // eslint-disable-next-line
      }, Monet.Utils.GetTabName()).render()
    };
  }

  componentDidMount() {
    const { user } = this.state;

    const criteriaChain = this.getCriteriaChain();

    user.setRequestBody(criteriaChain);

    const el = user.rootEl;
    const placeholder = Monet.I18n
      .getResourcesByKey('Greenmile.Chat.ReasignTicketModal.Lookup.Placeholder');
    el.children[2].children[0].firstElementChild.placeholder = placeholder;
    user.addListenerToAfterSelectRow(this.search);
    this.refs.user.appendChild(el);
  }

  componentDidUpdate() {
    const { user, visible } = this.state;

    if (!visible) {
      user.clear();
    }
    return true;
  }

  getCriteriaChain() {
    const {
      userId,
      availableUsers,
      availableGroups
    } = this.props;

    // TODO: Made the criteria with the availableUsers and availableGroups.

    const criteriaChain = {
      criteriaChain: [
        {
          and: [
            {
              attr: 'id',
              neq: userId
            },
            {
              attr: 'groups.name',
              neq: 'Driver'
            },
            {
              attr: 'enabled',
              eq: true
            }
          ]
        }
      ]
    };

    return criteriaChain;
  }

  search = ({ id }) => {
    const { afterSelectRow } = this.props;
    afterSelectRow('userId', id);
  }

  updateState(visible) {
    this.setState((oldState) => ({
      ...oldState,
      visible
    }));
  }

  render() {
    const { visible } = this.state;

    const display = (visible) ? 'inline-flex' : 'none';
    const styles = {
      display
    };
    return (
      <div ref="user" style={styles} />
    );
  }
}

User.propTypes = {
  userId: PropTypes.number.isRequired,
  availableUsers: PropTypes.array,
  availableGroups: PropTypes.array,
  afterSelectRow: PropTypes.func
};

User.defaultProps = {
  afterSelectRow: null,
  availableUsers: [],
  availableGroups: []
};

export default User;
